import styled from "styled-components";

export const Button = styled.button`
  ${({ disabled, variant }) => {
    if (disabled) {
      return `
        cursor: not-allowed;
        color: #868686;
        background-color: #DDD;
        border: none;
      `;
    } else {
      if (variant === "outlined") {
        return `
        color: #000000;
        background-color: #ffffff;
    
        cursor: pointer;
      `;
      }
      return `
        color: #ffffff;
        background-color: #000000;
        border: 1px solid #000000;
        cursor: pointer;
      `;
    }
  }}

  ${({ block, width }) => {
    if (width) {
      return `
        width: ${width}px;
      `;
    } else if (block) {
      return `
        width: 100%;
      `;
    } else {
      return ` 
        min-width: max-content;
      `;
    }
  }}


  outline: none;
  border-radius: 12px;
  padding: 14px 20px;
  font-weight: 500;
`;

export const SlideStyled = styled.div`
  width: 100%;
  flex: 1;
  height: 200px;
  display: grid;
  place-items: center;
`;

export const StepsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 24px;
  width: 100%;
  flex: 1;
`;

export const DPImageWrapper = styled.div`
  position: relative;
  min-width: max-content;
  width: max-content;
  height: max-content;
  min-height: max-content;
`;

export const DPImage = styled.img`
  position: relative;
  ${({ size }) => {
    let imgSize;
    switch (size) {
      case "md":
        imgSize = "360px";
        break;
      default:
        imgSize = "200px";
        break;
    }
    return `
       min-width: ${imgSize};
        max-width: ${imgSize};
        min-height: ${imgSize};
        max-height: ${imgSize};
    `;
  }}

  cursor: ${({ onClick }) => (onClick ? "pointer" : "default")};
  object-fit: contain;
  background-color: #4b4b4b;
  border-radius: 16px;
`;

export const DPPanImage = styled.img`
  position: relative;
  ${({ size }) => {
    let imgHeight;
    let imgWidth;

    switch (size) {
      case "md":
        imgHeight = "360px";
        imgWidth = "calc(360px * 1.55)";

        break;
      default:
        imgHeight = "200px";
        imgWidth = "300px";
        break;
    }
    return `
       min-width: ${imgWidth};
        max-width: ${imgWidth};
        min-height: ${imgHeight};
        max-height: ${imgHeight};
    `;
  }}

  cursor: ${({ onClick }) => (onClick ? "pointer" : "default")};
  object-fit: contain;
  background-color: #4b4b4b;
  border-radius: 16px;
`;

export const DividerContainer = styled.div`
  display: flex;
  max-width: 100%;
`;

export const LeftContainer = styled.div`
  width: max-content;
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 16px;
  border-right: 1px solid #f0f0f0;
`;

export const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 16px;
  min-width: 0;
  width: 100%;
`;

export const Header = styled.div`
  line-height: 22px;
  font-weight: 400;
  font-size: 16px !important;
  width: 100%;

  ${({ bold }) => bold && " font-weight: 500;"}
`;

export const SlidePadding = styled.div`
  padding: 20px 0px;
`;

export const CarouselHeading = styled.div`
  font-size: 20px !important;
  font-weight: 500;
  line-height: 28px;
  margin-bottom: 20px;
  padding: 0 20px;
`;
